// this error started appearing when adding a new network
// to the metamask if there are other extensions in the browser.
//  it appears on all websites, not just ours.
// it does not affect the process of adding a network in any way
// - it is added.

import { EMetamaskErrorCode, IMetamaskError } from 'modules/common/types';
import { isMetamaskError } from 'modules/common/utils/isMetamaskError';

export const isMetamaskInternalError = (
  error: unknown,
): error is IMetamaskError =>
  isMetamaskError(error) && error.code === EMetamaskErrorCode.Internal;
